import { render, staticRenderFns } from "./lookServer.vue?vue&type=template&id=1a0ee52b&scoped=true&"
import script from "./lookServer.vue?vue&type=script&lang=js&"
export * from "./lookServer.vue?vue&type=script&lang=js&"
import style0 from "./lookServer.vue?vue&type=style&index=0&id=1a0ee52b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ee52b",
  null
  
)

export default component.exports